import PageBannerEnerSol from "components/BannerSection/PageBannerEnerSol";
import CallToSectionTwo from "components/CallToSection/CallToSectionTwo";
import HeaderOne from "components/Header/HeaderOne";
import MobileMenu from "components/Header/MobileMenu";
import Layout from "components/Layout/Layout";
import MainFooter from "components/MainFooter/MainFooter";
import Style from "components/Reuseable/Style";
import SearchPopup from "components/SearchPopup/SearchPopup";
import React from "react";
import GallerySectionEnergySol from "components/GallerySection/GallerySectionEnergySol";
const EnergySolutions = () => {
  return (
    <Layout pageTitle="Energy Solutions">
      <Style />
      <HeaderOne />
      <MobileMenu />
      <SearchPopup />
      <PageBannerEnerSol
        title="Energy Solutions"
        parent="Services"
        parentHref="/services"
      />
      <GallerySectionEnergySol portfolio />
      <CallToSectionTwo className="alternate" />
      <MainFooter />
    </Layout>
  );
};

export default EnergySolutions;
